import React from 'react';
import { Flex, FlexProps, Text } from 'rebass';

type ModalHeaderProps = Omit<FlexProps, 'title'> & {
  title?: string | JSX.Element;
  children?: React.ReactNode;
};

const ModalHeader = (props: ModalHeaderProps): JSX.Element => (
  <Flex
    {...({
      ...props,
      title: undefined,
      children: undefined,
    } as any)}
    py={2}
    px={4}
    sx={{
      borderBottom: 1,
      flexGrow: 0,
      flexShrink: 0,
      borderBottomStyle: 'solid',
      borderColor: 'fieldBorder',
      ...props.sx,
    }}
  >
    <Text variant="heading1" display="flex" sx={{ gap: 2 }} alignItems="center">
      {props.title}
    </Text>
    {props.children}
  </Flex>
);

export default ModalHeader;
